/**
 * Entry point приложения
 * Инициализация Vue, Pinia, Router
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

// Создаём приложение
const app = createApp(App)

// Подключаем Pinia (state management)
const pinia = createPinia()
app.use(pinia)

// Подключаем Router
app.use(router)

// Монтируем приложение
app.mount('#app')
